import { signal } from "@preact/signals-react";

import type { OVD, PublicUser } from "@/shared/api/api-client";

export const ovdsState = signal<OVD[]>([]);
export const usersState = signal<PublicUser[]>([]);
